var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBenchmarkDeselected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 5.12833L9.07375 4.68917L7.08333 0L5.09292 4.69625L0 5.12833L3.8675 8.47875L2.70583 13.4583L7.08333 10.8162L11.4608 13.4583L10.3062 8.47875L14.1667 5.12833ZM7.08333 9.49167L4.42 11.0996L5.12833 8.06792L2.77667 6.02792L5.87917 5.75875L7.08333 2.90417L8.29458 5.76583L11.3971 6.035L9.04542 8.075L9.75375 11.1067L7.08333 9.49167Z",
    fill: "#454545"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBenchmarkDeselected);
export default __webpack_public_path__ + "static/media/icon_benchmark_deselected.cd18eeb095c262364091e7dd2a52bf95.svg";
export { ForwardRef as ReactComponent };